import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  IconButton,
  useMediaQuery,
  Typography,
  TablePagination,
  TextField,
} from "@mui/material";
import formatDate from "../../common/Formatdate";
import Bookingdetailstab from "./Bookingdetailstab";
import Refundprocess from "./Refundprocess";
import { BlinkBlur } from "react-loading-indicators";
import toast from "react-hot-toast";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";

function createData(
  id,
  createdOn,
  amount,
  bookingId,
  bookingType,
  bookingEndDate,
  customerName,
  customerEmail,
  mobile,
  refundStatus,
  action,
) {
  return {
    id,
    createdOn,
    amount,
    bookingId,
    bookingType,
    bookingEndDate,
    customerName,
    customerEmail,
    mobile,
    refundStatus, // use refundStatus instead of status
    action,
  };
}

const Refunds = ({ setActiveItem }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const bookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const refundStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.refundStatus;
  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  let bookingTypesDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  delete bookingTypesDuplicate?.inverted;
  const isMobile = useMediaQuery("(max-width:768px)");
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [allRefunds, setAllRefunds] = useState(null);
  const [cities, setCities] = useState(null);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openTab, setOpenTab] = useState(false);
  const [refundProcessTab, setRefundProcessTab] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedSearchButton, setSelectedSearchButton] = useState("");
  const [searchValues, setSearchValues] = useState(null);
  const [copied, setCopied] = useState(false);
  const [bookingTypesStatus, setBookingTypes] = useState(null);

  // const [selectedRowDatas, setSelectedRowData] = useState(null);
  // console.log("selele", selectedRowDatas);

  // useEffect(() => {
  //   if (selectedRow) {
  //     setSelectedRowData(
  //       allRefunds.find((item) => {
  //         item?.bookingId === selectedRow.bookingId;
  //       })
  //     );
  //   }
  // }, [selectedRow]);

  const columns = [
    { id: "id", label: "Id", minWidth: 70, align: "right" },
    { id: "createdOn", label: "Created On", minWidth: 150, align: "right" },
    { id: "amount", label: "Amount", minWidth: 150, align: "right" },
    { id: "bookingId", label: "Booking Id", minWidth: 200 },
    {
      id: "bookingType",
      label: "Booking Type",
      minWidth: 300,
      align: "center",
    },
    {
      id: "bookingEndDate",
      label: "Booking End Date",
      minWidth: 200,
      align: "right",
    },
    {
      id: "customerName",
      label: "Customer Name",
      minWidth: 150,
      align: "right",
    },
    {
      id: "customerEmail",
      label: "Customer Email",
      minWidth: 80,
      align: "right",
    },
    {
      id: "mobile",
      label: "Mobile",
      minWidth: 90,
      align: "right",
      format: (value) => value?.toFixed(2),
    },
    { id: "refundStatus", label: "Status", minWidth: 90, align: "right" },
    { id: "action", label: "Action", minWidth: 200, align: "right" },
  ];

  const rows =
    allRefunds?.map((item) =>
      createData(
        item?.id,
        formatDate(item?.createdAt),
        "₹ " + item?.refundableAmount,
        item?.bookingCode,
        (bookingTypes[item?.bookingType] ||
          bookingTypes[Number(bookingTypes?.inverted?.dailyRental)]) +
          ` (${moment(item?.bookingDetails?.bookTo).diff(moment(item?.bookingDetails?.bookFrom), "hours") < 24 ? `${moment(item?.bookingDetails?.bookTo).diff(moment(item?.bookingDetails?.bookFrom), "hours")} hours` : `${Math.floor(moment(item?.bookingDetails?.bookTo).diff(moment(item?.bookingDetails?.bookFrom), "hours") / 24)} days`})`,        
        item?.bookingEndDate,
        item?.customerName,
        item?.customerEmail || "-",
        item?.customerMobile,
        refundStatus[item?.refundStatus],
        String(item?.refundStatus) === String(refundStatus?.inverted?.pending)
          ? "Process Refund"
          : "View Details",
      ),
    ) || [];

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  useEffect(() => {
    getCityNames();
    getAllRefunds();
  }, []);

  const searchByFilter = [
    {
      label: "Booking Id",
      value: "bookingCode",
    },
    {
      label: "Customer Email",
      value: "contactEmail",
    },
    {
      label: "Customer Contact",
      value: "customerContactNo",
    },
  ];

  const getAllRefunds = async (
    customPage = page,
    customRowsPerPage = rowsPerPage,
    overrides = {},
  ) => {
    const offset = customPage * customRowsPerPage;

    const selectedSearchButtonLocal =
      overrides.selectedSearchButton !== undefined
        ? overrides.selectedSearchButton
        : selectedSearchButton;
    const searchValuesLocal =
      overrides.searchValues !== undefined
        ? overrides.searchValues
        : searchValues;
    if (searchValuesLocal && !selectedSearchButtonLocal) {
      return toast.error("Please select the search by category", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }
    if (selectedSearchButtonLocal && !searchValuesLocal) {
      return toast.error("Please enter the search value", {
        position: "top-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }
    let query = "";

    if (selectedSearchButtonLocal === "bookingCode") {
      query += `&bookingCode=${searchValuesLocal}`;
    } else if (selectedSearchButtonLocal === "contactEmail") {
      query += `&customerEmail=${searchValuesLocal}`;
    } else if (selectedSearchButtonLocal === "customerContactNo") {
      query += `&customerMobile=${searchValuesLocal}`;
    }
    if (bookingTypesStatus) {
      query += `&bookingType=${bookingTypesStatus}`;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/bookingrefunds?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setAllRefunds(data?.entities?.rows);
        setTotalCount(data?.entities?.count || 0);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getAllRefunds(0, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllRefunds(newPage, rowsPerPage);
  };

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  }; 

  const handleReset = () => {
    setSelectedSearchButton("");
    setSearchValues("");
    setBookingTypes(null);
    setPage(0);
    getAllRefunds(0, rowsPerPage, {
      selectedSearchButton: "",
      searchValues: "",
    });
  };

  return (
    <>
      {refundProcessTab ? (
        <Refundprocess
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setRefundProcessTab={setRefundProcessTab}
          getAllRefunds={getAllRefunds}
          setOpenTab={setOpenTab}
          setActiveItem={setActiveItem}
        />
      ) : openTab ? (
        <Bookingdetailstab
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setOpenTab={setOpenTab}
          getAllBookings={getAllRefunds}
        />
      ) : (
        <div>
          <h1 className="text-2xl font-medium mt-8">
            View all Booking Refunds
          </h1>
          <Box p={isMobile ? 2 : 1}>
            <Box
              display="flex"
              flexDirection="column"
              p={2}
              borderRadius={2}
              boxShadow={3}
              mb={4}
              sx={{ backgroundColor: "white" }}
            >
              <div className="grid grid-cols-12 mt-2">
                <h1 className="mt-2 col-span-2 text-start">Search By :</h1>
                <div className="col-span-9 flex gap-4">
                  <FormControl fullWidth size="small">
                    <InputLabel id="resntal-select-label">
                      Rental Types
                    </InputLabel>
                    <Select
                      labelId="resntal-select-label"
                      id="resntal-select"
                      value={bookingTypesStatus}
                      onChange={(e) => {
                        setPage(0);
                        setBookingTypes(e.target.value);
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200, // Limits dropdown height (optional)
                          },
                        },
                      }}
                    >
                      {bookingTypesDuplicate &&
                        Object.entries(bookingTypesDuplicate).map(
                          ([key, value]) => (
                            <MenuItem
                              sx={{
                                minHeight: 20, // Smaller height
                                paddingY: 0.5, // Compact vertical padding
                                fontSize: "0.8rem", // Smaller font (optional)
                              }}
                              key={key}
                              value={key}
                            >
                              {value}
                            </MenuItem>
                          ),
                        )}
                    </Select>
                  </FormControl>
                  {searchByFilter.map((item, index) => {
                    const isActive = item?.value === selectedSearchButton;
                    return (
                      <div key={index}>
                        <button
                          onClick={() => {
                            setPage(0);
                            setSearchValues(null);
                            setSelectedSearchButton(item?.value);
                          }}
                          className={`h-[40px] w-40 rounded-xl flex items-center justify-center transition-transform duration-200 active:scale-[0.95] border
                        ${
                          isActive
                            ? "bg-[linear-gradient(45deg,#efad21,#ffd60f)] border-transparent text-white font-medium text-md shadow-md"
                            : "bg-white border-black text-black hover:bg-gray-100"
                        }`}
                        >
                          <span className="font-normal leading-none transition-all duration-200">
                            {item?.label}
                          </span>
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="mt-8 grid grid-cols-12 gap-16">
                <div className="col-span-10">
                  <TextField
                    fullWidth
                    id="standard-basic"
                    label="Enter the value to search"
                    variant="standard"
                    value={searchValues}
                    onChange={(e) => {
                      setPage(0);
                      setSearchValues(e.target.value);
                    }}
                  />
                </div>

                <div className="col-span-2 flex items-center gap-4">
                  <button
                    onClick={() => {
                      setPage(0);
                      getAllRefunds();
                    }}
                    className="w-12 h-12 rounded-full bg-violet-500 group shadow-xl flex items-center justify-center relative overflow-hidden"
                  >
                    <svg
                      className="w-6 h-6 text-gray-800 relative z-10 dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="2"
                        d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                      />
                    </svg>

                    <div className="w-full h-full rotate-45 absolute left-[32%] top-[32%] bg-green-500 group-hover:-left-[100%] group-hover:-top-[100%] duration-1000"></div>
                    <div className="w-full h-full -rotate-45 absolute -left-[32%] -top-[32%] group-hover:left-[100%] group-hover:top-[100%] bg-green-500 duration-1000"></div>
                  </button>

                  <button
                    onClick={handleReset}
                    class="cursor-pointer transition-all bg-blue-500 text-white px-4 py-2 rounded-lg
          border-blue-600
          border-b-[4px] hover:brightness-110 hover:-translate-y-[1px] hover:border-b-[6px]
          active:border-b-[2px] active:brightness-90 active:translate-y-[2px]"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </Box>
          </Box>
          <Box mb={3}>
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                // marginTop: 4,
                boxShadow: 6,
                borderRadius: 2,
                paddingTop: 2,
                paddingLeft: 2,
                paddingRight: 2,
              }}
            >
              <TableContainer
                sx={{
                  overflowX: "auto",
                  overflowY: "100%",
                }}
              >
                <Table aria-label="sticky table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          sx={{
                            display: {
                              xs: column.hideOnMobile ? "none" : "table-cell",
                              sm: "table-cell",
                            },
                          }}
                          style={{ minWidth: column.minWidth }}
                          key={column.id}
                          align={column.align || "left"}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <div className="flex flex-col items-center h-40 justify-center">
                            <BlinkBlur
                              color={[
                                "#cd8032",
                                "#32cd32",
                                "#327fcd",
                                "#cd32cd",
                              ]}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : rows.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          No data found
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows.map((row, idx) => (
                        <TableRow hover key={idx}>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                sx={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setRefundProcessTab(true);
                                  setSelectedRow(row);
                                }}
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "action" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      setRefundProcessTab(true);
                                      setSelectedRow(row);
                                    }}
                                  >
                                    {value}
                                  </Button>
                                ) : column.id === "bookingId" ||
                                  column?.id === "mobile" ||
                                  column?.id === "customerEmail" ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <span>{value || "-"}</span>
                                    {value && (
                                      <>
                                        <ContentCopyIcon
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            navigator.clipboard.writeText(
                                              value,
                                            );
                                            setCopied(value);
                                            setTimeout(
                                              () => setCopied(""),
                                              1500,
                                            );
                                          }}
                                          sx={{
                                            fontSize: 20,
                                            cursor: "pointer",
                                            color:
                                              copied === value
                                                ? "green"
                                                : "grey",
                                            transition: "color 0.2s",
                                          }}
                                        />
                                      </>
                                    )}
                                  </Box>
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value || "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                  },
                }}
              />
            </Paper>
          </Box>
        </div>
      )}
    </>
  );
};

export default Refunds;
